export const reportRootPages = [
  {
    path: '/reports/:id',
    name: 'report_page_route',
    component: () => import('@/views/reports/TheReportPage.vue')
  }
]
